import { createSelector } from 'reselect';

export const selectNews = (state) => state.newsReducer?.news || {};

export const selectIsNewsLoading = (state) => state.newsReducer?.isNewsLoading;

export const selectLastNews = createSelector([selectNews], (news) => {
  const newsData = news?.data;
  return newsData ? newsData.slice(0, 2) : [];
});

export const selectNewsTags = (state) =>
  state.newsReducer?.hashtags?.data || [];

export const selectPublication = (state) =>
  state.newsReducer?.publication || {};
